export default "__VITE_ASSET__CvfGwh_P__"